// extracted by mini-css-extract-plugin
module.exports = {"Chat":"Chat_Chat__lgG6O"};